import { useState, useEffect } from 'react'
import { Radio, RadioGroup, FormControl, FormControlLabel, FormHelperText, Box, Typography } from '@mui/material'

function InterpreterQuestion ({ onValidationChange, showErrors, formData, onFormDataChange }) {
  const [errors, setErrors] = useState({})

  const handleChange = (e) => {
    onFormDataChange({ interpreterNeeded: e.target.value })
  }

  useEffect(() => {
    const newErrors = {}
    if (!formData.interpreterNeeded) newErrors.interpreterNeeded = 'Please select whether you need an interpreter'
    setErrors(newErrors)
    onValidationChange(Object.keys(newErrors).length === 0)
  }, [formData, onValidationChange])

  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant='h6'>Do you need an interpreter?</Typography>
      <FormControl required component='fieldset' error={!!errors.interpreterNeeded && showErrors}>
        <RadioGroup value={formData.interpreterNeeded || ''} onChange={handleChange}>
          <FormControlLabel value='true' control={<Radio />} label='Yes' />
          <FormControlLabel value='false' control={<Radio />} label='No' />
        </RadioGroup>
        {showErrors && errors.interpreterNeeded && (<FormHelperText>{errors.interpreterNeeded}</FormHelperText>)}
      </FormControl>
    </Box>
  )
}

export default InterpreterQuestion
